// MusicStateMachine — pure, priority-aware audio-state resolver (client mirror of the
// backend resolve_transition rules). It decides HOW a transition should occur; it never
// produces sound. Safety states (danger/skill/result) transition immediately; lower-priority
// ambient requests never yank away an active safety state.
export class MusicStateMachine {
  constructor(catalog) {
    this.catalog = catalog || {};
    this.current = null;
  }

  setCatalog(catalog) { this.catalog = catalog || {}; }

  _priority(state) {
    return (this.catalog[state] && this.catalog[state].priority) || 0;
  }

  _isSafety(state) {
    return !!(this.catalog[state] && this.catalog[state].safety_immediate);
  }

  resolve(target) {
    if (!this.catalog[target]) return { allowed: false, reason: "unknown_state" };
    if (this.current === target) return { allowed: true, type: "none", duration_ms: 0, interrupt: false };
    const curP = this._priority(this.current);
    const tgtP = this._priority(target);
    if (this._isSafety(target)) return { allowed: true, type: "immediate_safety", duration_ms: 250, interrupt: true };
    if (tgtP < curP && this._isSafety(this.current)) {
      return { allowed: false, reason: "lower_priority_than_active_safety_state" };
    }
    const dur = (this.catalog[target] && this.catalog[target].transition_duration_ms) || 1200;
    return { allowed: true, type: "bar_aligned", duration_ms: dur, interrupt: tgtP >= curP };
  }

  request(target) {
    const r = this.resolve(target);
    if (r.allowed && r.type !== "none") this.current = target;
    return r;
  }
}

export default MusicStateMachine;
